import { useTheme, type Theme } from '@shared/hooks';
import {
  SegmentedControl,
  type SegmentedControlOption,
} from './segmented-control';

const THEME_OPTIONS: readonly SegmentedControlOption<Theme>[] = [
  { value: 'light', label: <span className="text-sm">亮色</span> },
  { value: 'dark', label: <span className="text-sm">深色</span> },
];

/**
 * 亮色／深色切換，選了立即套用並記在這台裝置上。
 *
 * 用分段控制而非開關：兩個選項都有名字，使用者看得到自己選的是什麼。開關要靠標籤
 * 說明「開」代表哪一邊，深色模式尤其容易讀反。
 *
 * 刻意不提供「跟隨系統」：那會讓看到的主題同時取決於本站與裝置兩處設定，出問題要查
 * 兩個地方，而使用者往往不知道自己當初選的是哪一種。
 */
export function ThemeSwitcher() {
  const { theme, setTheme } = useTheme();

  return (
    <SegmentedControl
      value={theme}
      options={THEME_OPTIONS}
      onChange={setTheme}
      ariaLabel="主題"
    />
  );
}
